import React, { useState, useEffect, useRef, useContext } from "react";
import { useParams } from "react-router-dom";

import { getSolicitudesEdicionId } from "../../../../Base/API/Proveedores/ProveedoresRequest";

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Chips } from "primereact/chips";
import { toastShow } from "../../../../Base/Services/ToastService";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { ConfirmDialog } from "primereact/confirmdialog";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { PDFDocument } from "pdf-lib";

import { getDateStringCeros } from "../../../../Base/Services/Moment/Luxon";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { useForm } from "../../../../Base/Hooks/useForm";
import { logoPPFBase64 } from "../../../../utils/Imagenes/Imgs";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { formatDate } from "../../../../Base/Services/FechasService";
import { fuentesBase64 } from "../../../../Base/Styles/vfs_fonts/vfs_fonts";
import { obtenerNombreEmpresa } from "../../../../Base/Utils/Funciones/Funciones";

// pdfMake.vfs = pdfFonts.pdfMake.vfs;

const esVerdadero = (valor) => {
  if (valor === null || valor === undefined) return false;
  if (typeof valor === "boolean") return valor;
  if (typeof valor === "number") return valor === 1;
  const v = String(valor).trim().toLowerCase();
  return ["1", "true", "si", "sí", "s"].includes(v);
};

const renderCheckboxRow = (valor, label) => ({
  columns: [
    {
      width: 12,
      canvas: [
        {
          type: "rect",
          x: 0,
          y: 0,
          w: 10,
          h: 10,
          r: 1,
          lineWidth: 1,
          lineColor: "#000000",
          color: esVerdadero(valor) ? "#000000" : undefined,
        },
      ],
      margin: [2, 2, 0, 0],
    },
    {
      width: "*",
      text: label,
      style: "checkboxLabel",
      margin: [4, 0, 0, 0],
    },
  ],
  columnGap: 2,
});

const SECCIONES = [
  { key: "InformacionEmpresa", label: "Información de Empresa" },
  { key: "InformacionContacto", label: "Información de Contacto" },
  { key: "InformacionBancaria", label: "Información Bancaria" },
  { key: "InformacionComercial", label: "Información Comercial" },
  { key: "InformacionFinanciera", label: "Información Financiera" },
  { key: "Documentacion", label: "Documentación" },
  { key: "Reactivar", label: "Reactivar" },
  { key: "HabilitarPago", label: "Habilitar Pago" },
];

const ReporteSolicitudEdicionProveedor = ({
  dialog,
  hideDialog,
  IdSolicitudEdicion,
}) => {
  const toast = useRef(null);
  const [data, setData] = useState({});
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [buffer, setBuffer] = useState(null);
  const { userAuth } = useContext(AuthContext);

  const obtenerInformacion = async () => {
    try {
      const tempoEnc = await getSolicitudesEdicionId(IdSolicitudEdicion);

      console.log("Respuesta API:", tempoEnc);

      let dataEnc = tempoEnc;
      if (Array.isArray(tempoEnc) && tempoEnc.length > 0) {
        dataEnc = tempoEnc[0];
      }

      console.log("Datos procesados:", dataEnc);

      if (dataEnc && dataEnc.IdSolicitudEdicion) {
        setData(dataEnc);
        await GenerarPDF(dataEnc);
      } else {
        toastShow(toast, 'error', 'No se encontró información de la solicitud');
      }
    } catch (error) {
      console.error("Error al obtener información:", error);
      toastShow(toast, 'error', 'Error al cargar la solicitud');
    }
  };

  const GenerarPDF = async (tempoEnc) => {
    const empresa = obtenerNombreEmpresa(new Date());

    const nombreProveedor = tempoEnc.NombreProveedor || 'Proveedor no disponible';
    const codigoProveedor = tempoEnc.CodigoCompany || 'N/A';

    const fechaFormateada = tempoEnc.Fecha ? 
      (tempoEnc.Fecha.includes('/') ? tempoEnc.Fecha : getDateStringCeros(tempoEnc.Fecha)) : 'N/A';

    const filasSecciones = SECCIONES.map(({ key, label }) => [
      {
        ...renderCheckboxRow(tempoEnc[key], label),
        colSpan: 2,
      },
      { text: "" },
    ]);

    const docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "portrait",
      pageMargins: [40, 70, 30, 70],
      defaultStyle: { font: "Roboto" },

      header: function() {
        return {
          margin: [0, 0, 0, 0],
          table: {
            widths: [180, 250, 100],
            body: [
              [
                {
                  image: logoPPFBase64.logo,
                  width: 150,
                  alignment: 'left',
                  margin: [0, 0, 0, 0]
                },
                {
                  text: `${empresa.NombreEmpresaMayuscula} PERFORMANCE FABRICS\nSOLICITUD DE EDICIÓN DE PROVEEDOR`,
                  alignment: "center",
                  fontSize: 12,
                  bold: true,
                  margin: [0, 20, 0, 0]
                },

              ],
            ],
          },
          layout: {
            defaultBorder: false,
          },
        };
      },

      content: [
        {
          margin: [0, 10, 0, 0],
          table: {
            widths: [120, "*"],
            body: [
              [
                {
                  text: "Código Proveedor:",
                  style: "label",
                },
                {
                  text: `${codigoProveedor} - ${nombreProveedor}`,
                  style: "value",
                },
              ],
              [
                {
                  text: "Número Correlativo:",
                  style: "label",
                },
                { 
                  text: tempoEnc.Correlativo || 'N/A', 
                  style: "value" 
                },
              ],
              [
                { 
                  text: "Fecha Solicitud:", 
                  style: "label" 
                },
                {
                  text: fechaFormateada,
                  style: "value",
                },
              ],

              [
                {
                  text: "Información a Modificar:",
                  style: "labelSection",
                  colSpan: 2,
                  margin: [0, 10, 0, 5],
                },
                { text: "" },
              ],
              ...filasSecciones,
              [
                {
                  text: "",
                  colSpan: 2,
                  border: [false, true, false, false],
                  margin: [0, 10, 0, 0],
                },
                { text: "" },
              ],
              [
                { 
                  text: "Comentario:", 
                  style: "label" 
                },
                {
                  text: tempoEnc.Comentario && tempoEnc.Comentario.trim() !== "" ? tempoEnc.Comentario : "Sin comentario",
                  style: "value",
                },
              ],
              [
                {
                  text: "",
                  colSpan: 2,
                  border: [false, true, false, false],
                  margin: [0, 10, 0, 0],
                },
                { text: "" },
              ],
              [
                {
                  colSpan: 2,
                  table: {
                    widths: ["auto", "*", "auto", "*"],
                    body: [
                      [
                        { text: "Firma quien Solicita:", style: "label", border: [false, false, false, false] },
                        { text: "_____________________________", style: "value", border: [false, false, false, false] },
                        { text: "Firma quien Autoriza:", style: "label", border: [false, false, false, false] },
                        { text: "_____________________________", style: "value", border: [false, false, false, false] },
                      ],
                    ],
                  },
                  layout: "noBorders",
                  margin: [0, 80, 0, 0],
                },
                { text: "" },
              ],
            ],
          },
          layout: {
            defaultBorder: false,
            hLineWidth: function (i, node) {
              return 0;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
          },
        },
      ],

      footer: function(currentPage, pageCount) {
        return {
          margin: [40, 0, 40, 20],
          stack: [
            {
              table: {
                widths: ["*"],
                body: [
                  [
                    {
                      text: `${empresa.NombreEmpresaMinuscula || ''} Performance Fabrics S.A. de C.V.`,
                      style: "textoEmpresa",
                      alignment: "center",
                      margin: [0, 5, 0, 0],
                    },
                  ],
                  [
                    {
                      text: `Km. 19.5 Carretera a occidente, La Acequia, Quimistán, Naco, Santa Bárbara, Honduras, C.A.`,
                      style: "textoDireccion",
                      alignment: "center",
                    },
                  ],
                ],
              },
              layout: {
                defaultBorder: false,
              },
            },
            {
              columns: [
                { text: '', width: '33%' },
                {
                  text: `Solicitado por: ${userAuth?.UserName || ''}`,
                  alignment: 'center',
                  fontSize: 9,
                  width: '34%'
                },
                {
                  text: `Impreso: ${formatDate(new Date())}`,
                  alignment: 'center',
                  fontSize: 9,
                  width: '33%'
                }
              ],
              margin: [0, 0, 0, 0],
            }
          ]
        };
      },

      styles: {
        label: {
          fontSize: 11,
          alignment: "left",
          margin: [0, 5, 0, 0],
          bold: true
        },
        labelSection: {
          fontSize: 11,
          alignment: "left",
          margin: [0, 5, 0, 0],
          bold: true,
          decoration: 'underline'
        },
        checkboxLabel: {
          fontSize: 10,
          alignment: "left",
          margin: [0, 2, 0, 0],
        },
        value: {
          fontSize: 11,
          alignment: "left",
          margin: [0, 5, 0, 0],
        },
        textoEmpresa: {
          fontSize: 10,
          alignment: "center",
          bold: true,
          margin: [0, 5, 0, 0],
        },
        textoDireccion: {
          fontSize: 9,
          alignment: "center",
          lineHeight: 1.2,
        },
        tableEnc: {
          fontSize: 9,
          bold: true,
          alignment: "center",
        },
        textoCentrado: {
          fontSize: 10,
          alignment: "center",
          bold: true,
        },
      },
    };

    try {
      const doc = pdfMake.createPdf(docDefinition);
      const f = document?.getElementById("pdfSolicitud");
      const callback = function (url) {
        f?.setAttribute("src", url);
      };
      doc.getDataUrl(callback, doc);

      const reporteBuffer = await new Promise((resolve) => {
        doc.getDataUrl((url) => resolve(url));
      });

      const response = await fetch(reporteBuffer);
      const arrayBuffer = await response.arrayBuffer();
      setBuffer(arrayBuffer);
    } catch (error) {
      console.error("Error al generar PDF:", error);
      toastShow(toast, 'error', 'Error al generar el PDF');
    }
  };

  useEffect(() => {
    if (dialog) {
      if (IdSolicitudEdicion > 0) {
        obtenerInformacion();
      }
    } else {
      setData({});
    }
  }, [dialog, IdSolicitudEdicion]);

  return (
    <Dialog
      visible={dialog}
      onHide={hideDialog}
      style={{ width: "75vw", height: "100%" }}
      header={
        <div className="d-flex gap pt-2">
          <h3>
            {data?.NombreProveedor || data?.ProveedorNombre || "Solicitud de Edición"}
            {data?.CodigoCompany && ` (${data.CodigoCompany})`}
          </h3>
        </div>
      }
    >
      <Toast ref={toast} />

      <div style={{ overflowY: "auto" }}>
        <div
          className="d-flex gap justify-content-between pt-4"
          style={{
            position: "sticky",
            zIndex: 10,
            paddingBottom: "0.5rem",
          }}
        >
        </div>

        <div className="d-flex justify-content-center">
          <iframe
            id="pdfSolicitud"
            src=""
            style={{ width: "100%", height: "85vh", border: "1px solid #ccc" }}
            className="my-4"
          />
        </div>
      </div>
    </Dialog>
  );
};

export default ReporteSolicitudEdicionProveedor;